// Подпись подложки: чего требуют условия поставщика и как это нарисовать.
//
// До 27.08.2026 в витрине не было НИ ОДНОЙ атрибуции, то есть не выполнялось
// требование и того поставщика, на котором мы жили годами:
//
//   * Carto — «CARTO and OpenStreetMap attribution must stay on your maps —
//     that is what the free tier is in exchange for»;
//   * Яндекс — знак в углу карты, кликабельный на Яндекс Карты, на русском или
//     английском; отступы уже внутри картинки, своих добавлять не нужно.
//
// Артворк лежит ЗДЕСЬ, а не в описателе подложки (`basemap.ts`): тот остаётся
// чистой логикой без единого килобайта картинок и без зависимости от того, как
// Vite подаёт ассеты.

import type { BasemapSpec } from '../basemap'
import yandexRu from './yandexLogoRu.svg?raw'
import yandexEn from './yandexLogoEn.svg?raw'

/** Официальный знак Яндекса на языке кабинета.
 *
 *  Языка ровно ДВА — столько разрешают условия («на двух языках — русском и
 *  английском»), поэтому всё, что не русский, получает английский. Артворк
 *  взят из набора Яндекса как есть: белое гало под чёрными глифами и красная
 *  «Я» — это их читаемость поверх чужой картинки, и перерисовывать её нам
 *  запрещено (п. 5.1.2: «удалять, изменять… логотипы»). */
export function yandexLogoSvg(lang: string): string {
  return lang === 'ru' ? yandexRu : yandexEn
}

export type AttributionView =
  | { kind: 'text'; text: string; href: string }
  | { kind: 'logo'; svg: string; altKey: string; href: string }

/** Что рисовать поверх карты для этой подложки. */
export function attributionView(spec: BasemapSpec, lang: string): AttributionView {
  const a = spec.attribution
  if (a.kind === 'logo') {
    return { kind: 'logo', svg: yandexLogoSvg(lang), altKey: a.altKey, href: a.href }
  }
  return a
}
